export default __webpack_public_path__ + "static/wicrypt-6c2b35ca57998ab86e63dd7f07cee682.svg";